import { useAccessResource } from "./useAccessResource";
import { creatorPopAccessService } from "../services/creatorPopAccessService";

export const useCreatorPopAccess = (username, userId) =>
  useAccessResource(username, userId, creatorPopAccessService);
